export const CALENDAR_VIEW_MODES = {
  MONTH: 'MONTH',
  WEEK: 'WEEK'
}

export const CALENDAR_ENTITY_TYPES = {
  ALL: 'ALL',
  TEAMS: 'TEAMS',
  INDIVIDUAL: 'INDIVIDUAL'
}